import { AppError } from '../../framework/models/errors';
import { env } from '../../framework/utils/EnvUtils';
import { TypeUtils } from '../../framework/utils/UtilityTypes';

// @see https://github.com/madefor/postal-code-api

type PostalCodeAddressPart = {
  prefecture: string;
  address1: string;
  address2: string;
  address3: string;
  address4: string;
};

export type PostalCodeAddress = {
  code: string;
  data: [
    {
      prefcode: string;
      ja: PostalCodeAddressPart;
      en: PostalCodeAddressPart;
    }
  ];
};

export const ZipCodeUtils = {
  divide(zipCode?: string) {
    return this.isValidHyphen(zipCode)
      ? zipCode!.split('-')
      : [zipCode!.slice(0, 3), zipCode!.slice(3)];
  },
  isValidHyphen(zipCode?: string) {
    return !TypeUtils.isNilString(zipCode) && /^\d{3}-\d{4}$/.test(zipCode);
  },
  isValidNoHyphen(zipCode?: string) {
    console.log(/^\d{7}$/.test(zipCode!));
    return !TypeUtils.isNilString(zipCode) && /^\d{7}$/.test(zipCode);
  },
  removeHyphen(zipCode?: string) {
    if (this.isValidHyphen(zipCode)) {
      const [upper, lower] = this.divide(zipCode);
      return `${upper}${lower}`;
    }
    return this.isValidNoHyphen(zipCode) ? zipCode : undefined;
  },
  async zipCodeToAddress(zipCode?: string): Promise<PostalCodeAddress> {
    if (TypeUtils.isNil(zipCode)) {
      throw new AppError(
        undefined,
        '郵便番号が不正です',
        undefined,
        'WARNING',
        undefined,
        '郵便番号検索'
      );
    }
    // validation

    if (!this.isValidHyphen(zipCode) && !this.isValidNoHyphen(zipCode)) {
      throw new AppError(
        undefined,
        '郵便番号が不正です',
        undefined,
        'WARNING',
        undefined,
        '郵便番号検索'
      );
    }

    const [upper, lower] = this.divide(zipCode);

    const response = await fetch(
      `${env.ZIP_CODE_TO_ADDRESS_API_ENDPOINT}/${upper}/${lower}.json`
    );
    if (!response.ok) {
      throw new AppError(
        undefined,
        '指定された郵便番号に該当する住所は検索できませんでした',
        undefined,
        'WARNING',
        undefined,
        '郵便番号検索'
      );
    }
    return await response.json();
  },
};
